import SignalContent from "../signal_content";

export function changeSignallampFlash(
  self: SignalContent,
  signallampSensorData: any,
) {
  if (signallampSensorData && self.lampColors.length > 0) {
    for (let i = 0; i < 4; i++) {
      const status = signallampSensorData[`lamp${i + 1}_state`];
      self.lampColors[i].flush = false;
      if (status > 0) {
        self.lampColors[i].flush = true;
      }
    }
  }
}
